<template>
  <div class="row">
    <div class="col-md-4 form-group">
      <label>Tipo</label>
      <select
        v-model="value.property_type"
        class="form-control"
        :disabled="disabled"
      >
        <option value="">
          Selecione
        </option>
        <option value="casa">
          Casa
        </option>
        <option value="apartamento">
          Apartamento
        </option>
        <option value="comercio">
          Comércio
        </option>
        <option value="terreno">
          Terreno
        </option>
        <option value="outro">
          Outro
        </option>
      </select>
    </div>
    <div class="col-md-8 form-group">
      <label>Endereço</label>
      <input
        v-model="value.address"
        type="text"
        class="form-control"
        :disabled="disabled"
        placeholder="Rua, número, bairro"
      >
    </div>

    <div class="col-12 form-group">
      <label>Ponto de referência</label>
      <input
        v-model="value.reference"
        type="text"
        class="form-control"
        :disabled="disabled"
      >
    </div>

    <div class="col-12 form-group">
      <label>Descrição</label>
      <input
        v-model="value.description"
        type="text"
        class="form-control"
        :disabled="disabled"
        placeholder="Ex: imóvel de esquina, portão azul"
      >
    </div>

    <div class="col-12 form-group">
      <label>Observação</label>
      <textarea
        v-model="value.observation"
        class="form-control"
        rows="2"
        :disabled="disabled"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'InvolvedPropertyForm',
  props: {
    value: { type: Object, required: true },
    errors: { type: Object, default: () => ({}) },
    disabled: { type: Boolean, default: false },
  },
}
</script>
